export default "__VITE_ASSET__B1kh5XZx__"